// src/stage2/sceneExterior/BikesField.jsx
import React from "react";
import { Bike } from "./Bike";

export const BIKES = [
    { id: 1, pos: [6.25, 1.8, 22.1], color: "#ac0d10" },
    { id: 2, pos: [9.18, 1.8, 22.07], color: "#b61fb1" },
    { id: 3, pos: [11.35, 1.8, 22.1], color: "#3498db" },
    { id: 4, pos: [15.6, 1.8, 21.99], color: "#27ae60" },
    { id: 5, pos: [19.27, 1.8, 22.1], color: "#e3b10c" },
  ];


export function BikesField({ onRideStart, onBikeNearChange, bikesLiveRef, disabled = false }) {

  return (
    <>
      {BIKES.map((b) => (
        <Bike
          key={b.id}
          bikeId={b.id}
          position={b.pos}
          color={b.color}
          scale={1}
          disabled={disabled}
          onNearChange={onBikeNearChange}
          onMountRequest={(bikeId) => onRideStart?.(bikeId)}
          bikesLiveRef={bikesLiveRef}
        />
      ))}
    </>
  );
}
